import { render } from "./view_service.html?vue&type=template&id=5f8cf9e6&external"
import script from "./view_service.js?vue&type=script&lang=js&external"
export * from "./view_service.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__